import React, { Component } from "react";
import { Tooltip } from "@mui/material"; // Import Tooltip
import ministriesData from "../../source/ministries.json"; // Ensure this path is correct

class MinistriesPanel extends Component {
  renderTile = (ministry) => {
    // Truncate the description if it's too long
    const truncatedDesc =
      ministry.desc && ministry.desc.length > 200
        ? `${ministry.desc.substring(0, 200)}...`
        : ministry.desc;

    return (
      <div className="feature-item p-3 ministry-tile d-flex flex-column align-items-start">
        <h4 className="mb-3">{ministry.name}</h4> {/* Changed to h4 for better semantics */}
        <img
          className="img-fluid ministry-image"
          src={ministry.image}
          alt={`${ministry.name} ministry`}
        />

        {/* Tooltip to show the full description */}
        <Tooltip title={ministry.desc} arrow>
          <p className="mb-3">
            {truncatedDesc}
          </p>
        </Tooltip>

        {ministry.url && (
          <a href={ministry.url} className="btn btn-outline-primary">
            Read More <i className="bi bi-arrow-right-circle" />
          </a>
        )}
      </div>
    );
  };

  render() {
    return (
      <div className="container-fluid p-0" style={{ backgroundColor: "#f9f6f2" }}>
        {/* Header Section */}
        <div className="text-center mb-3 py-1">
          <h2 className="display-4">Our Ministries</h2>
        </div>

        {/* Ministry Tiles Section displaying only the first 4 */}
        <div className="container-fluid feature bg-light">
          <div className="row g-4">
            {ministriesData.slice(0, 6).map((ministry, index) => (
              <div
                key={index}
                className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
                data-wow-delay={`${0.2 * (index + 1)}s`}
              >
                {this.renderTile(ministry)}
              </div>
            ))}
          </div>
          <div className="mb-4" /> {/* Add space below all tiles */}
        </div>
      </div>
    );
  }
}

export default MinistriesPanel;
